import React from 'react';
import Icon from '../../../components/AppIcon';

const TimelineVisualization = ({ milestones }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'bg-success text-success-foreground';
      case 'in-progress': return 'bg-warning text-warning-foreground';
      case 'pending': return 'bg-muted text-muted-foreground';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed': return 'CheckCircle';
      case 'in-progress': return 'Clock';
      case 'pending': return 'Circle';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-soft">
      <div className="p-6">
        <h3 className="text-lg font-semibold text-foreground mb-6">Transaction Timeline</h3>
        
        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-border" />
          
          <div className="space-y-6">
            {milestones?.map((milestone, index) => (
              <div key={milestone?.id} className="relative flex items-start space-x-4">
                {/* Timeline Dot */}
                <div className={`relative z-10 w-12 h-12 rounded-full flex items-center justify-center ${getStatusColor(milestone?.status)}`}>
                  <Icon name={getStatusIcon(milestone?.status)} size={20} />
                </div>
                
                {/* Content */}
                <div className="flex-1 min-w-0 pb-6">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-medium text-foreground">{milestone?.title}</h4>
                    <span className="text-sm text-muted-foreground">{milestone?.date}</span>
                  </div>
                  
                  <p className="text-sm text-muted-foreground mb-3">{milestone?.description}</p>
                  
                  {milestone?.documents && milestone?.documents?.length > 0 && (
                    <div className="space-y-2">
                      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
                        Related Documents
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {milestone?.documents?.map((doc, docIndex) => (
                          <div key={docIndex} className="flex items-center space-x-1 px-2 py-1 bg-muted rounded text-xs">
                            <Icon name="FileText" size={12} />
                            <span>{doc}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {milestone?.stakeholders && milestone?.stakeholders?.length > 0 && (
                    <div className="mt-3">
                      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide mb-2">
                        Involved Stakeholders
                      </p>
                      <div className="flex -space-x-2">
                        {milestone?.stakeholders?.map((stakeholder, stakeholderIndex) => (
                          <div 
                            key={stakeholderIndex}
                            className="w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-medium border-2 border-background"
                            title={stakeholder}
                          >
                            {stakeholder?.charAt(0)}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  
                  {milestone?.status === 'in-progress' && milestone?.progress && (
                    <div className="mt-3">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-xs text-muted-foreground">Progress</span>
                        <span className="text-xs font-medium text-foreground">{milestone?.progress}%</span>
                      </div>
                      <div className="w-full bg-muted rounded-full h-1.5">
                        <div 
                          className="bg-warning h-1.5 rounded-full transition-all duration-300"
                          style={{ width: `${milestone?.progress}%` }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        {/* Next Milestone Preview */}
        <div className="mt-6 pt-6 border-t border-border">
          <div className="flex items-center space-x-3 p-3 bg-accent/5 rounded-lg">
            <Icon name="Calendar" size={16} className="text-accent" />
            <div>
              <p className="text-sm font-medium text-foreground">Next Milestone</p>
              <p className="text-xs text-muted-foreground">Property inspection scheduled for March 28, 2025</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineVisualization;